export const WebexHowItWorks: React.FC = () => {
  return (
    <div>
      Zocks' Webex integration allows you to have your Zocks AI Notetaker with you on your Webex meetings so that you can focus on your client while Zocks
      captures accurate, actionable, and 100% recording-free notes, so you never miss a detail.
    </div>
  )
}
